import { FC } from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Divider } from 'antd';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ProcActions } from '@/pages/proc/ProcActions';
import { ProcDetailsResponse } from '@/shared/api';
import { useRouterContext } from '@/shared/router';
import { themeConfig, useThemeContext } from '@/shared/theme';
import { Row } from '@/shared/ui';

type Props = {
  proc?: ProcDetailsResponse;
};

export const PublishedProcViewPageHeader: FC<Props> = ({ proc }) => {
  const navigate = useNavigate();
  const { theme } = useThemeContext();
  const { dashboardGoBackLink } = useRouterContext();

  return (
    <HeaderWrapper>
      <Button
        type="text"
        icon={<ArrowLeftOutlined style={{ fontSize: 12 }} />}
        onClick={() => navigate(dashboardGoBackLink)}
        style={{
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          minWidth: 132,
        }}
      >
        Go back to dashboard
      </Button>
      <Row
        justifyContent="flex-end"
        gap={0}
        style={{ height: 20, width: '100%' }}
      >
        <ProcActions proc={proc} />
        <Divider
          type="vertical"
          style={{
            fontSize: 35,
            borderInlineStart: `1px solid ${themeConfig[theme].colors.border}]}`,
            top: 0,
            marginLeft: 10,
          }}
        />
      </Row>
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
